var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimliArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 32,
    viewBox: "0 0 143 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 16H25.3334M6.66669 16L13.3334 9.33331M6.66669 16L13.3334 22.6666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.182 1.31094C131.756 2.22102 130.946 3.34995 130.946 4.44204C130.896 6.86891 134.484 5.56446 134.403 7.82882C134.403 8.8494 133.631 9.97616 131.902 9.97616C130.064 9.97616 128.115 8.55688 128.115 5.78982C128.115 2.51354 130.834 0.728061 133.631 0L134.182 1.31094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.815 1.31094C139.389 2.22102 138.58 3.34995 138.58 4.44204C138.529 6.86891 142.117 5.56446 142.036 7.82882C142.036 8.8494 141.264 9.97616 139.536 9.97616C137.698 9.97616 135.748 8.55688 135.748 5.78982C135.748 2.51354 138.468 0.728061 141.264 0L141.815 1.31094Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.3 12.4139C130.038 12.4139 128.881 12.1148 128.054 11.6338V31.4041H134.468V11.6685C133.648 12.13 132.532 12.4139 131.3 12.4139Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22.6045H46.614C46.8525 24.9317 48.3665 27.2221 52.4316 27.2221C56.1378 27.2221 57.6912 25.5254 57.6912 23.8288C57.6912 22.1322 56.7745 20.9491 53.4686 20.3965L49.8039 19.805C43.5488 18.78 41.0392 16.0563 41.0392 11.3998C41.0392 6.74321 45.2619 2.99457 52.0749 2.99457C59.6844 2.99457 63.4301 7.13758 63.9486 11.9133H57.3346C56.9364 9.66412 55.4618 7.7703 52.0356 7.7703C48.8084 7.7703 47.5329 9.42794 47.5329 10.8884C47.5329 12.663 48.5284 13.4929 51.8365 14.0455L55.1839 14.559C61.3188 15.5449 64.7056 18.3467 64.7056 23.2394C64.7056 28.5265 60.2029 32 52.5125 32C44.8221 32 40.3588 28.0888 40 22.6045Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2374 11.6338H86.3766V13.805C87.453 12.2665 89.1661 11.0422 91.9141 11.0422C94.8218 11.0422 96.6946 12.5417 97.7317 14.3185C98.8869 12.6219 101.119 11.0422 104.186 11.0422C108.608 11.0422 111.596 13.6078 111.596 18.5395V31.4041H105.26L105.3 19.4474C105.3 17.1982 104.383 15.935 102.193 15.935C100.003 15.935 98.9263 17.4734 98.9263 19.961V31.4041H92.949V19.4474C92.949 17.1982 92.0323 15.935 89.8006 15.935C87.569 15.935 86.6129 17.5536 86.6129 19.961V31.4041H80.2374V11.6338Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.499 3.58398H122.914V31.4041H116.499V3.58398Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8294 12.4139C70.6107 12.4139 69.5058 12.1343 68.6876 11.6815V31.4041H75.1024V11.6338C74.2754 12.1148 73.0918 12.4139 71.8294 12.4139Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8359 2.99243C74.1069 2.99243 75.5816 4.5699 75.5816 6.42472C75.5816 8.27954 74.1069 9.97618 71.8359 9.97618C69.5649 9.97618 68.2106 8.35755 68.2106 6.42472C68.2106 4.49189 69.5649 2.99243 71.8359 2.99243Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimliArrowBack);
export default __webpack_public_path__ + "static/media/simli_ArrowBack.40f78c762dd5b509915599997023a4b1.svg";
export { ForwardRef as ReactComponent };